export default __webpack_public_path__ + "static/media/tassel_shape.4c11c7b6.jpeg";